import { gql } from '@efficiently/client-core-graphql-models';

export const ASSIGN_TAG_TO_CONTENT = gql(`
	mutation AssignTagToContent($tagAssignments: [TagToContentInput!]!) {
		assignTagToContent(tagAssignments: $tagAssignments) {
			...TagFields
		}
	}
`);
